import type { JSX } from 'react';
import { useState } from 'react';
import { Link } from 'react-router-dom';

import Close from '@mui/icons-material/Close';
import MenuIcon from '@mui/icons-material/Menu';
import CssBaseline from '@mui/material/CssBaseline';
import Divider from '@mui/material/Divider';
import Drawer from '@mui/material/Drawer';
import IconButton from '@mui/material/IconButton';
import List from '@mui/material/List';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import Toolbar from '@mui/material/Toolbar';
import styled from 'styled-components';

const StyledToolbar = styled(Toolbar)`
  width: 100%;
  display: flex;
  justify-content: flex-end;
`;

const Root = styled.div`
  z-index: 10;
  overflow: visible;
`;

const DrawerHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
`;

interface HamburgerProps {
  iconColor?: string;
}

function Hamburger({
  iconColor = '#00843d'
}: HamburgerProps): JSX.Element {
  const [open, setOpen] = useState(false);

  const handleDrawerOpen = () => {
    setOpen(true);
  };

  const handleDrawerClose = () => {
    setOpen(false);
  };

  return (
    <Root>
      <CssBaseline />

      <StyledToolbar>
        <IconButton
          aria-label="open drawer"
          edge="start"
          onClick={handleDrawerOpen}
          className={open ? 'hidden' : ''}
          data-testid="hamburger"
          sx={{ color: iconColor }}
        >
          <MenuIcon htmlColor={iconColor} />
        </IconButton>
      </StyledToolbar>

      <Drawer
        anchor="right"
        open={open}
        sx={{
          '& .MuiDrawer-paper': {
            overflow: 'visible',
            height: '100vh',
            width: '105vw',
            top: 0
          },
          '@media (max-width: 414px)': {
            '& .MuiDrawer-paper': { width: '103vw' }
          },
          '@media (max-width: 411px)': {
            '& .MuiDrawer-paper': { width: '103vw' }
          },
          '@media (max-width: 360px)': {
            '& .MuiDrawer-paper': { width: '105vw' }
          },
          '@media (max-width: 320px)': {
            '& .MuiDrawer-paper': { width: '100vw' }
          }
        }}
      >
        <DrawerHeader>
          <IconButton
            onClick={handleDrawerClose}
            sx={{ color: iconColor }}
          >
            <Close
              data-testid="close"
              htmlColor={iconColor}
            />
          </IconButton>
        </DrawerHeader>

        <Divider />

        <List>
          <ListItemButton
            component={Link}
            to="/help"
          >
            <ListItemText primary="Contact Support" />
          </ListItemButton>

          <ListItemButton
            component={Link}
            to="/logout"
          >
            <ListItemText primary="Logout" />
          </ListItemButton>

          <ListItemButton
            component={Link}
            to="/secure/form/review"
          >
            <ListItemText primary="Review" />
          </ListItemButton>
        </List>

        <Divider />
      </Drawer>
    </Root>
  );
}

export default Hamburger;